(() => {
  const content = document.querySelector('.ohmm-earbuds-content');
  if (!content || document.documentElement.dataset.m76CroBound === 'true') return;
  document.documentElement.dataset.m76CroBound = 'true';
  const header = document.querySelector('.header');
  if (header && !header.querySelector('.ohmm-smart-header-nav')) {
    const nav = document.createElement('nav');
    nav.className = 'header__inline-menu ohmm-smart-header-nav';
    nav.setAttribute('aria-label', 'Product information');
    nav.innerHTML = '<ul class="ohmm-smart-header-nav__list" role="list"><li><a href="#translation-demo">How it works</a></li><li><a href="#compatibility">Compatibility</a></li><li><a href="/policies/shipping-policy">Shipping &amp; returns</a></li></ul>';
    const icons = header.querySelector('.header__icons');
    if (icons) header.insertBefore(nav, icons);
    else header.appendChild(nav);
  }
  document.querySelectorAll('.product__media-wrapper .product-media-container').forEach(container => {
    if (!container.querySelector('img') || container.querySelector('[data-earbuds-zoom]')) return;
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'ohmm-earbuds-gallery-zoom';
    button.setAttribute('data-earbuds-zoom', '');
    button.setAttribute('aria-label', 'Enlarge product image');
    button.textContent = 'Enlarge ↗';
    container.appendChild(button);
  });
  const packs = document.querySelector('.ohmm-earbuds-packs');
  const updatePackButtons = () => {
    const selected = document.querySelector('.ohmm-earbuds-packs')?.querySelector('input[name="quantity"]:checked');
    const pack = selected?.nextElementSibling;
    if (!pack) return;
    const quantity = Number(selected.value);
    const label = `${quantity} ${quantity === 1 ? 'pair' : 'pairs'}`;
    const price = pack.dataset.packPrice;
    const primary = document.querySelector('.product-form__submit');
    if (primary && !primary.disabled) {
      primary.querySelector(':scope > span').textContent = `Add ${label} to cart — ${price}`;
    }
    const sticky = document.querySelector('.sticky-atc');
    if (sticky) {
      sticky.querySelector('.sticky-atc__price').textContent = price;
      const button = sticky.querySelector('button[type="submit"]');
      if (button && !button.disabled) button.querySelector(':scope > span').textContent = `Add ${label}`;
    }
  };
  document.addEventListener('change', event => { if (event.target.closest('.ohmm-earbuds-packs')) updatePackButtons(); });
  updatePackButtons();
  const updateVariantPhotos = () => {
    const selected = document.querySelector('variant-radios input[name="Color"]:checked');
    const mapping = document.querySelector('[data-m76-color-images]');
    if (!selected || !mapping) return;
    let sources;
    try { sources = JSON.parse(mapping.textContent); } catch { return; }
    const source = sources[selected.value];
    if (source) document.querySelectorAll('.ohmm-earbuds-pack__image img').forEach(image => { image.src = source; });
  };
  document.addEventListener('change', event => {
    if (event.target.closest('variant-radios, variant-selects')) updateVariantPhotos();
  });
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, () => { updateVariantPhotos(); updatePackButtons(); });
  }
  updateVariantPhotos();
  const dialog = document.querySelector('.ohmm-earbuds-image-dialog');
  let trigger;
  let previousOverflow;
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-earbuds-zoom]');
    if (!button || !dialog) return;
    const source = button.querySelector('img') || button.closest('.product-media-container')?.querySelector('img');
    if (!source) return;
    trigger = button;
    const image = dialog.querySelector('img');
    image.src = source.currentSrc || source.src;
    image.alt = source.alt;
    previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    dialog.showModal();
    const viewport = dialog.querySelector('.ohmm-earbuds-image-dialog__viewport');
    viewport.scrollTo({top: 0, left: 0});
  });
  dialog?.querySelector('[data-earbuds-zoom-close]').addEventListener('click', () => dialog.close());
  dialog?.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
  });
  dialog?.addEventListener('close', () => {
    document.body.style.overflow = previousOverflow || '';
    trigger?.focus({preventScroll: true});
  });
  const cards = content.querySelector('.ohmm-earbuds-uses');
  const controls = Array.from(content.querySelectorAll('[data-earbuds-use]'));
  controls.forEach(button => button.addEventListener('click', () => {
    const card = cards.children[Number(button.dataset.earbudsUse)];
    if (!card) return;
    cards.scrollTo({left: card.offsetLeft - cards.children[0].offsetLeft, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
  }));
  let ticking = false;
  cards?.addEventListener('scroll', () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      const origin = cards.children[0].offsetLeft;
      let selected = 0;
      let distance = Infinity;
      Array.from(cards.children).forEach((card, index) => {
        const nextDistance = Math.abs(card.offsetLeft - origin - cards.scrollLeft);
        if (nextDistance < distance) { distance = nextDistance; selected = index; }
      });
      controls.forEach((button, index) => button.setAttribute('aria-pressed', String(index === selected)));
      ticking = false;
    });
  }, {passive: true});
})();
